import { IDatepickerInteractionsProps } from '@/interfaces';

export const handleOnChange = ({
  date,
  onChange,
  hookFormOnChange,
}: IDatepickerInteractionsProps<string | Date | string[] | Date[]>) => {
  if (onChange) onChange(date);
  if (hookFormOnChange) hookFormOnChange(date);
};
